import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { PropType, ref } from "vue";
import { Document, Line } from "@/types";
import DocumentLine from "@/components/pages/document/parts/lines/DocumentLine.vue";
import { useSortable } from "@vueuse/integrations/useSortable";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLines',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    lines: {
        type: Array as PropType<Line[]>,
        required: true,
    },
    editable: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;

const el = ref<HTMLElement | null>(null);
useSortable(el, props.lines, {
    handle: ".DocumentLine__handle",
    onEnd: (e: Event) => {
        let arrayOrder = 0;
        setTimeout(() => {
            for (const line of props.lines) {
                line.arrayOrder = arrayOrder;
                arrayOrder++;
            }
        });
    },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    ref_key: "el",
    ref: el
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lines, (line) => {
      return (_openBlock(), _createBlock(DocumentLine, {
        key: line.id,
        document: __props.document,
        locked: !__props.editable,
        currency: __props.document.currency,
        line: line
      }, null, 8, ["document", "locked", "currency", "line"]))
    }), 128))
  ], 512))
}
}

})